import {ReactComponent as LocMark} from './images/icon-location.svg'
import {Marker , MapContainer , TileLayer , Popup   } from 'react-leaflet'
import {renderToStaticMarkup} from 'react-dom/server' ;
import {divIcon} from 'leaflet'


function Map({data , load}) {
  const position = [data.lat, data.lng]

  const iconMarkup = renderToStaticMarkup(<LocMark className='icon-loc'  />);
  const customMarkerIcon = divIcon({
    html: iconMarkup,
    className :'loacmark' ,
    // popupAnchor: [0, 40]
    iconSize : [50 , 50] ,
    // iconAnchor: [24, 35] ,
    
    
  });


  return (
    
        <MapContainer  zoomControl={false}  className='map' center={position} zoom={13} scrollWheelZoom={false}>
            <TileLayer 
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker   icon={customMarkerIcon} position={position}>
              
              <Popup>
                Here is {data.city}
              </Popup>
            </Marker>
       </MapContainer>
    
  )
}

export default Map